<div class="container">
  <div fxLayout="row" fxLayoutAlign="space-between start" class="header">
    <div fxLayout="column" fxLayoutAlign="start start">
      <div class="sub-title">
        {{ subTitle + (lastUpdateDate ? ' - Dernière mise à jour le ' + lastUpdateDate : '') }}
      </div>
      <div class="title">
        {{ title }}
      </div>
    </div>

    <div (click)="close()" class="close-btn">
      <mat-icon class="icon">close</mat-icon>
    </div>
  </div>

  <div class="body" fxLayout="column" fxLayoutAlign="start start">
    <ng-container *ngIf="period === 'DAY'; else nightDetails">
      <div class="per-service" fxLayout="column" fxLayoutAlign="start start" *ngFor="let item of $any(details)">
        <div class="service" *ngIf="details && details.length > 1">
          {{ item.hospital.displayName }}
        </div>

        <div class="details" fxLayout="row" fxLayoutAlign="start start">
          <div class="item" fxLayout="column" fxLayoutAlign="start stretch">
            <div class="item-header light-blue-background" fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <div class="formations">Total</div>
                <div *ngIf="!onlyNeeds; else noEffHeader" class="effective-needs-text">Effectif/Besoin</div>
                <ng-template #noEffHeader>
                  <div class="effective-needs-text">Besoins</div>
                </ng-template>
              </div>
              <div *ngIf="!onlyNeeds" class="objectif-status-container">
                <app-objectif-status class="objectif-status" [status]="item.objectifStatus"> </app-objectif-status>
              </div>
            </div>

            <div class="periods" fxLayout="row" fxLayoutAlign="space-between center">
              <div
                class="period"
                fxLayout="column"
                fxLayoutAlign="start start"
                *ngIf="onlyMorning || (!onlyMorning && !onlyAfternoon)"
              >
                <div class="period-text">Matin</div>

                <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                  <div *ngIf="!onlyNeeds; else totalNoEffMorning">
                    {{ item.morning.effective }} / {{ item.morning.needs }}
                  </div>
                  <ng-template #totalNoEffMorning>
                    <div>
                      {{ item.morning.needs }}
                    </div>
                  </ng-template>
                  <div
                    *ngIf="showDifference"
                    class="difference"
                    [class.green-text]="getDifference(item.morning) >= 0"
                    [class.red-text]="getDifference(item.morning) < 0"
                  >
                    &nbsp; ({{
                      getDifference(item.morning) >= 0
                        ? '+' + getDifference(item.morning)
                        : getDifference(item.morning)
                    }})
                  </div>
                </div>
              </div>

              <div
                class="period"
                fxLayout="column"
                fxLayoutAlign="start start"
                *ngIf="onlyAfternoon || (!onlyMorning && !onlyAfternoon)"
              >
                <div class="period-text">Après-midi</div>

                <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                  <div *ngIf="!onlyNeeds; else totalNoEffAfternoon">
                    {{ item.afternoon.effective }} / {{ item.afternoon.needs }}
                  </div>
                  <ng-template #totalNoEffAfternoon>
                    <div>
                      {{ item.afternoon.needs }}
                    </div>
                  </ng-template>

                  <div
                    *ngIf="showDifference"
                    class="difference"
                    [class.green-text]="getDifference(item.afternoon) >= 0"
                    [class.red-text]="getDifference(item.afternoon) < 0"
                  >
                    &nbsp; ({{
                      getDifference(item.afternoon) >= 0
                        ? '+' + getDifference(item.afternoon)
                        : getDifference(item.afternoon)
                    }})
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngFor="let population of populationsDetails"
            class="item"
            fxLayout="column"
            fxLayoutAlign="start stretch"
          >
            <div class="item-header blue-background" fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <div class="formations">{{ population.name }}</div>
                <div *ngIf="!onlyNeeds; else noEffHeader" class="effective-needs-text">
                  <p style="margin-top: 0">[{{ population.formationsNames }}]</p>
                  <p style="margin-top: 0">Effectif/Besoin</p>
                </div>
                <ng-template #noEffHeader>
                  <div class="effective-needs-text">Besoins</div>
                </ng-template>
              </div>
              <div *ngIf="!onlyNeeds" class="objectif-status-container">
                <app-objectif-status class="objectif-status" [status]="objectifStatus(population)">
                </app-objectif-status>
              </div>
            </div>

            <div class="periods" fxLayout="row" fxLayoutAlign="space-between center">
              <div
                class="period"
                fxLayout="column"
                fxLayoutAlign="start start"
                *ngIf="onlyMorning || (!onlyMorning && !onlyAfternoon)"
              >
                <div class="period-text">Matin</div>

                <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                  <div *ngIf="!onlyNeeds; else totalNoEffMorning">
                    {{ population.morning.effective }} / {{ population.morning.needs }}
                  </div>
                  <ng-template #totalNoEffMorning>
                    <div>
                      {{ population.morning.needs }}
                    </div>
                  </ng-template>
                  <div
                    *ngIf="showDifference"
                    class="difference"
                    [class.green-text]="getDifference(population.morning) >= 0"
                    [class.red-text]="getDifference(population.morning) < 0"
                  >
                    &nbsp; ({{
                      getDifference(population.morning) >= 0
                        ? '+' + getDifference(population.morning)
                        : getDifference(population.morning)
                    }})
                  </div>
                </div>
              </div>

              <div
                class="period"
                fxLayout="column"
                fxLayoutAlign="start start"
                *ngIf="onlyAfternoon || (!onlyMorning && !onlyAfternoon)"
              >
                <div class="period-text">Après-midi</div>

                <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                  <div *ngIf="!onlyNeeds; else totalNoEffAfternoon">
                    {{ population.afternoon.effective }} / {{ population.afternoon.needs }}
                  </div>
                  <ng-template #totalNoEffAfternoon>
                    <div>
                      {{ population.afternoon.needs }}
                    </div>
                  </ng-template>

                  <div
                    *ngIf="showDifference"
                    class="difference"
                    [class.green-text]="getDifference(population.afternoon) >= 0"
                    [class.red-text]="getDifference(population.afternoon) < 0"
                  >
                    &nbsp; ({{
                      getDifference(population.afternoon) >= 0
                        ? '+' + getDifference(population.afternoon)
                        : getDifference(population.afternoon)
                    }})
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngFor="let data of item.data">
            <div class="item" fxLayout="column" fxLayoutAlign="start stretch">
              <div class="item-header" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                  <div class="formations">{{ data.title }}</div>
                  <div *ngIf="!onlyNeeds; else noEffHeader" class="effective-needs-text">Effectif/Besoin</div>
                  <ng-template #noEffHeader>
                    <div class="effective-needs-text">Besoins</div>
                  </ng-template>
                </div>
                <div *ngIf="!onlyNeeds" class="objectif-status-container">
                  <app-objectif-status class="objectif-status" [status]="data.objectifStatus"> </app-objectif-status>
                </div>
              </div>

              <div class="periods" fxLayout="row" fxLayoutAlign="space-between center">
                <div
                  class="period"
                  fxLayout="column"
                  fxLayoutAlign="start start"
                  *ngIf="onlyMorning || (!onlyMorning && !onlyAfternoon)"
                >
                  <div class="period-text">Matin</div>

                  <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                    <div *ngIf="!onlyNeeds; else noEffMorning">
                      {{ data.morning.effective }} / {{ data.morning.needs }}
                    </div>
                    <ng-template #noEffMorning>
                      <div>
                        {{ data.morning.needs }}
                      </div>
                    </ng-template>

                    <div
                      *ngIf="showDifference"
                      class="difference"
                      [class.green-text]="getDifference(data.morning) >= 0"
                      [class.red-text]="getDifference(data.morning) < 0"
                    >
                      &nbsp; ({{
                        getDifference(data.morning) >= 0
                          ? '+' + getDifference(data.morning)
                          : getDifference(data.morning)
                      }})
                    </div>
                  </div>
                </div>

                <div
                  class="period"
                  fxLayout="column"
                  fxLayoutAlign="start start"
                  *ngIf="onlyAfternoon || (!onlyMorning && !onlyAfternoon)"
                >
                  <div class="period-text">Après-midi</div>

                  <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                    <div *ngIf="!onlyNeeds; else noEffAfternoon">
                      {{ data.afternoon.effective }} / {{ data.afternoon.needs }}
                    </div>
                    <ng-template #noEffAfternoon>
                      <div>
                        {{ data.afternoon.needs }}
                      </div>
                    </ng-template>

                    <div
                      *ngIf="showDifference"
                      class="difference"
                      [class.green-text]="getDifference(data.afternoon) >= 0"
                      [class.red-text]="getDifference(data.afternoon) < 0"
                    >
                      &nbsp; ({{
                        getDifference(data.afternoon) >= 0
                          ? '+' + getDifference(data.afternoon)
                          : getDifference(data.afternoon)
                      }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #nightDetails>
      <div class="per-service" fxLayout="column" fxLayoutAlign="start start" *ngFor="let item of $any(details)">
        <div class="service" *ngIf="details && details.length > 1">
          {{ item.hospital.displayName }}
        </div>

        <div class="details" fxLayout="row" fxLayoutAlign="start start">
          <div class="item" fxLayout="column" fxLayoutAlign="start stretch">
            <div class="item-header light-blue-background" fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <div class="formations">Total</div>
                <div class="effective-needs-text">Effectif/Besoin</div>
              </div>
              <div class="objectif-status-container">
                <app-objectif-status class="objectif-status" [status]="item.objectifStatus"> </app-objectif-status>
              </div>
            </div>

            <div class="periods" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="period" fxLayout="column" fxLayoutAlign="start start">
                <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                  <div>{{ item.effective || 0 }} / {{ item.needs || 0 }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="item" fxLayout="column" fxLayoutAlign="start stretch" *ngFor="let data of item.data">
            <div class="item-header" fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <div class="formations">{{ data.reasonMap.code }}</div>
                <div class="effective-needs-text">Effectif/Besoin</div>
              </div>
              <div class="objectif-status-container">
                <app-objectif-status class="objectif-status" [status]="data.objectifStatus"> </app-objectif-status>
              </div>
            </div>

            <div class="periods" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="period" fxLayout="column" fxLayoutAlign="start start">
                <div class="effective-needs" fxLayout="row" fxLayoutAlign="start center">
                  <div>{{ data.effective }} / {{ data.needs }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
